import LiveMap from '@/components/orders/new-order/live-map/LiveMap';
import s from '@/components/orders/new-order/live.module.css';
import { MapLayerToggles } from './MapLayerToggles';
import { NotificationBell } from './NotificationBell';
import { MAP_LAYERS } from '../hooks/useMapLayers';

export const LiveMapSection = ({
	isMasterOrAdmin,
	switchDisplay,
	user,
	// Whether the map is on screen: «Προβολή» on a computer, «Εμφάνιση
	// χάρτη» on a phone (see Live.jsx).
	mapShown,
	isMobile,
	togglePhoneMap,
	mapWidth,
	mapHeight,
	positions,
	shopPositions,
	layers,
	toggleLayer,
	finalActiveOrders,
	activityVisible,
	toggleActivity,
	activityFeed,
}) => {
	return (
		<div className={s.mapColumn}>
			{isMasterOrAdmin && (
				<div className={s.displayButtons}>
					{isMobile ? (
						<div className={s.displayButton} onClick={togglePhoneMap}>
							{mapShown ? 'Απόκρυψη χάρτη' : 'Εμφάνιση χάρτη'}
						</div>
					) : (
						<div className={s.displayButton} onClick={switchDisplay}>
							Προβολή
						</div>
					)}
					<div className={s.displayButton} onClick={toggleActivity}>
						{activityVisible ? 'Απόκρυψη χρονολογίου' : 'Χρονολόγιο'}
					</div>
					<NotificationBell />
				</div>
			)}
			{isMasterOrAdmin &&
				user?.cityLocation?.location &&
				mapShown && (
					<div
						className={`${s.mapContainer} relative`}
						style={{ width: mapWidth, height: mapHeight }}
					>
						<MapLayerToggles layers={layers} toggleLayer={toggleLayer} />
						<LiveMap
							initLocation={user?.cityLocation?.location}
							positions={{
								...(layers?.[MAP_LAYERS.DELIVERIES] ? positions || {} : {}),
								...(shopPositions || {}),
							}}
							orders={layers?.[MAP_LAYERS.DESTINATIONS] && finalActiveOrders}
							traffic={layers?.[MAP_LAYERS.TRAFFIC]}
							colorZonesCity={isMasterOrAdmin ? user?.cityLocation : null}
							width={mapWidth}
							height={mapHeight}
							forDeliveries
							page='live'
							// One map per browser tab, re-shown on every return to Live
							// instead of a new (billed) one each time.
							persistKey='live'
						/>
					</div>
				)}

			{/* Under the map on every width. The map column is narrow, so the feed
			    gets the same width rather than the form's — and it stays put when the
			    map is hidden, because history is still worth reading then. */}
			{isMasterOrAdmin && activityVisible && (
				<div className={s.activityContainer} style={{ width: mapWidth }}>
					{activityFeed}
				</div>
			)}
		</div>
	);
};
